import { Eye, EyeOff } from "lucide-react";

import { cn } from "@/lib/utils";

interface EyeIconProps {
  className?: string;
  size?: number;
}

export function EyeIcon({ className, size = 20 }: EyeIconProps) {
  return <Eye size={size} className={cn("w-5 h-5", className)} />;
}

export function EyeOffIcon({ className, size = 20 }: EyeIconProps) {
  return <EyeOff size={size} className={cn("w-5 h-5", className)} />;
}

interface PasswordToggleIconProps extends EyeIconProps {
  isVisible: boolean;
}

export function PasswordToggleIcon({
  isVisible,
  className,
  size = 20,
}: PasswordToggleIconProps) {
  return isVisible ? (
    <EyeOffIcon className={className} size={size} />
  ) : (
    <EyeIcon className={className} size={size} />
  );
}
